import React from 'react';
import { Color, Brand, Size } from '../../../lib/theme';
import { useStyles, cx } from '../../../lib/styles';
import iconStyles from './Icon_styles';

/**
 * The Material icons we support.
 * https://fonts.google.com/icons?selected=Material+Icons
 * Use the Icons prop for material icons. Alternatively, pass a null value for Icons
 * and pass classes for Line Awesome icons - https://icons8.com/line-awesome
 **/
export type Icons =
  | 'flight'
  | 'thumb_up'
  | 'hotel'
  | 'directions_boat'
  | 'local_activity'
  | 'local_bar'
  | 'directions_bus'
  | 'wifi'
  | 'edit'
  | 'public'
  | 'brightness_3'
  | 'brightness_6'
  | 'expand_less'
  | 'expand_more'
  | 'arrow_drop_down'
  | 'chevron_left'
  | 'chevron_right'
  | 'directions_train'
  | 'local_offer'
  | 'local_mall'
  | 'directions_car'
  | 'help_outline'
  | 'wb_sunny'
  | 'phone'
  | 'watch_later'
  | 'visibility'
  | 'local_hotel'
  | 'arrow_forward'
  | 'person'
  | 'person_pin'
  | 'star'
  | 'email'
  | 'favorite'
  | 'close'
  | 'check'
  | 'navigation'
  | 'search'
  | 'error'
  | 'person'
  | 'airport_shuttle'
  | 'local_parking'
  | 'terrain'
  | 'free_breakfast'
  | 'stars'
  | 'bonus'
  | 'card_giftcard'
  | 'accessibility_new'
  | 'airline_seat_recline_extra'
  | 'comment'
  | 'check_circle'
  | 'error_outline'
  | 'bookmark'
  | 'menu'
  | 'explore'
  | 'contact_support'
  | 'arrow_right_alt'
  | 'account_circle'
  | 'shopping_cart'
  | 'verified'
  | 'redeem'
  | 'record_voice_over'
  | 'date_range'
  | 'date_range'
  | 'autorenew'
  | 'check_circle_outline'
  | 'highlight_off'
  | 'history'
  | 'calendar_month'
  | 'attach_money'
  | 'schedule'
  | null;

export interface IconProps {
  /** The icon to display. */
  icon: Icons;

  /** The font size to display the icon in or a fixed pixel size. */
  size?: number | Size;

  /** The label of the icon. */
  label?: string;

  /** Whether to wrap the icon in a padded container. */
  container?: boolean;

  /** The brand to use for colouring the icon. */
  brand?: Brand;

  /**
   * The color to display the color in.
   *
   * @default 'currentColor'
   */
  color?: Color;

  /** Any additional classnames to add to the container element. */
  className?: string;

  /** An event listener for when the icon is clicked. */
  onClick?: (...args: any[]) => any;

  rotateIcon?: boolean;
}

/**
 * A Material icon.
 */
export const Icon = (props: IconProps) => {
  const { label, icon, className, onClick } = props;
  const styles = useStyles(iconStyles(props));

  return (
    <i
      className={cx(
        'Icon',
        icon ? styles.materialIcon : '',
        styles.icon,
        className
      )}
      onClick={onClick}
      aria-label={label}
    >
      {icon}
    </i>
  );
};

export default Icon;
